var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcX02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52729 3.52876C3.78764 3.26841 4.20975 3.26841 4.4701 3.52876L7.9987 7.05735L11.5273 3.52876C11.7876 3.26841 12.2098 3.26841 12.4701 3.52876C12.7305 3.78911 12.7305 4.21122 12.4701 4.47157L8.94151 8.00016L12.4701 11.5288C12.7305 11.7891 12.7305 12.2112 12.4701 12.4716C12.2098 12.7319 11.7876 12.7319 11.5273 12.4716L7.9987 8.94297L4.4701 12.4716C4.20975 12.7319 3.78764 12.7319 3.52729 12.4716C3.26694 12.2112 3.26694 11.7891 3.52729 11.5288L7.05589 8.00016L3.52729 4.47157C3.26694 4.21122 3.26694 3.78911 3.52729 3.52876Z",
    fill: "#E75858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcX02);
export default __webpack_public_path__ + "static/media/ic-x-02.834556bc66a4e41addc9deb2aa139ae6.svg";
export { ForwardRef as ReactComponent };